module.exports = __webpack_public_path__ + "media/images/wallet-55da8e425708cc35a20b90b03f8faaa2.jpeg";